import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react'

import { Link } from 'gatsby'
import React from 'react'
import SVGLogoText from '../../images/icons/logo-text.svg'

const MenuItems = ({ children }) => (
  <Button colorScheme='teal' variant='link' mt={{ base: 4, md: 0 }} mr={6} display='block'>
    {children}
  </Button>
  // <Text mt={{ base: 4, md: 0 }} mr={6} display="block">
  //   {children}
  // </Text>
)

const Header2 = (props) => (
  <div className='font-sans bg-white dark:bg-gray-90 w-full h-18 flex flex-row items-center'>
    <div>
      <img src={SVGLogoText} className='h-6'/>
    </div>
    <div>Login</div>
  </div>
)

const Header = (props) => (
  <nav className='flex items-center text-white justify-between flex-wrap p-6'>
    <Link to='/'>
      <div className='flex items-center flex-no-shrink text-white mr-6'>
        <img src={SVGLogoText} className='h-6 m-3'/>
      </div>
    </Link>
    <div className='block lg:hidden'>
      <button className='flex items-center px-3 py-2 border rounded text-white-lighter border-white-light hover:text-white hover:border-white'>
        <svg className='h-4 w-4' viewBox='0 0 20 20' fill='white' xmlns='http://www.w3.org/2000/svg'><title>Menu</title><path d='M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z'/></svg>
      </button>
    </div>
    <div className='w-full block flex-gro lg:flex lg:items-end lg:w-auto'>
      <div className='text-sm lg:flex-grow'>
        {/* <a href='#responsive-header' className='block mt-4 lg:inline-block lg:mt-0 text-white hover:text-white mr-4'>
          About
        </a> */}
        <a href='https://strum.us/blogs' className='block mt-4 lg:inline-block lg:mt-0 text-white hover:text-white mr-4'>
          Blog
        </a>
      </div>
      <div className='hidden lg:block'>
        <a href='https://app.strum.us' className='border focus:outline-none hover:bg-blue-800 active:bg-blue-300 text-white px-5 py-2 rounded text-sm text-bold text-gray-200 h-8 cursor-pointer'>Log in</a>
      </div>
    </div>
  </nav>
)

const HeaderOld = (props) => {
  const [show, setShow] = React.useState(false)
  const handleToggle = () => setShow(!show)

  return (
    <Flex
      as='nav'
      align='center'
      justify='space-between'
      wrap='wrap'
      padding='1.5rem'
      color='black'
      {...props}
    >
      <Flex align='center' mr={5}>
        <Heading as='h1' size='lg' letterSpacing={'-.1rem'}>
          <img src={SVGLogoText}/>
        </Heading>
      </Flex>
      <div>
        SVGLogoText
      </div>

      <Box display={{ base: 'block', md: 'none' }} onClick={handleToggle}>
      </Box>

      <Box
        display={{ sm: show ? 'block' : 'none', md: 'flex' }}
        width={{ sm: 'full', md: 'auto' }}
        alignItems='center'
        flexGrow={1}
      >
        <MenuItems>Home</MenuItems>
        <MenuItems>About</MenuItems>
      </Box>

      <Box
        display={{ sm: show ? 'block' : 'none', md: 'block' }}
        mt={{ base: 4, md: 0 }}
      >
        <Button bg='transparent' border='1px' size='sm'>
          Sign up
        </Button>
      </Box>
    </Flex>
  )
}

export default Header
